<template>
  <base-label :class="labelClass" :for="name">
    <span
      >{{ label }} <icon-asterisk v-if="required" class="w-2 h-2 mb-2 inline"
    /></span>
    <p v-if="error" class="text-error text-xs font-medium">{{ error }}</p>
    <select
      :value="modelValue"
      @input="
        $emit('update:modelValue', ($event.target as HTMLSelectElement).value)
      "
      v-bind="$attrs"
      :name="name"
      class="block p-3 w-full bg-white border rounded-sm appearance-none pr-10"
      :class="{
        'mt-2 sm:mt-4': label,
        'border-red-600 placeholder-red-600': hasErrors && dirty,
        'text-secondary2': !modelValue,
      }"
      :required="required"
    >
      <option value="" disabled selected>{{ placeholder }}</option>
      <option
        v-for="country in countries"
        :key="country.value"
        :value="country.value"
      >
        {{ country.label }}
      </option>
    </select>
    <span v-if="hasErrors && modelValue" class="text-red-600 text-xs">
      {{ errorMessage }}
    </span>
  </base-label>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { allCountries } from 'country-region-data'
import IconAsterisk from '@/components/icons/IconAsterisk.vue'

defineOptions({
  inheritAttrs: false,
})

const props = withDefaults(
  defineProps<{
    error: string
    modelValue: string
    label?: string
    labelClass?: string
    required: boolean
    placeholder: string
    validation: any
  }>(),
  {
    required: false,
    placeholder: 'Select a country',
    validation: () => ({}),
  }
)

defineEmits(['update:modelValue'])

const name = computed(() => props.label?.toLowerCase())
const hasErrors = computed(() => !!props.validation?.$errors?.length)
const errorMessage = computed(() => props.validation?.$errors?.[0]?.$message)
const dirty = computed(() => props.validation?.$dirty)
const countries = computed(() =>
  allCountries.map(country => ({
    value: country[1],
    label: country[0],
  }))
)
</script>
<style scoped>
select {
  background-image: none;
}
</style>
